import { useTranslation } from "react-i18next";

const Disclaimer = ({
    className,
    textClassName,
    p1ClassName,
    p2ClassName,
    p3ClassName,
    p4ClassName,
    withTitle = false,
    titleClassName = "tw:!text-[16px] tw:!text-[#282828] tw:!text-[500] tw:!mb-5"
}) => {
    const { t } = useTranslation();
    return (
        <div className={className}>
            {
                withTitle && (
                    <p className={`${titleClassName}`}>{t("componentDisclaimer.title")}</p>
                )
            }
            <p className={`${textClassName} ${p1ClassName}`}>{t("componentDisclaimer.content.P1")}</p>
            <p className={`${textClassName} ${p2ClassName}`}>{t("componentDisclaimer.content.P2")}</p>
            <p className={`${textClassName} ${p3ClassName}`}>{t("componentDisclaimer.content.P3")}</p>
            <p className={`${textClassName} ${p4ClassName}`}>{t("componentDisclaimer.content.P4")}</p>
        </div>
    );
};

export default Disclaimer;
